export default __webpack_public_path__ + "static/media/9.27f26506.jpeg";